import { securityFilter, type FieldType } from './securityFilter';

type Formatter = (value: number) => string;

const MONEY_KEYS = new Set<string>([
  'spend',
  'new_spend',
  'new_user_spend',
  'revenue',
  'net_sales',
  'sales_amt',
  'sales_target',
  'new_net_sales',
  'old_net_sales',
  'net_sales_last_year',
  'new_net_sales_last_year',
  'old_net_sales_last_year',
  'new_base_payable',
  'base_net_sales',
  'first_order_pay',
  'sce_sales',
  'new_sales',
  'avg_price',
  'customer_price',
  'order_avg_price',
  'product_avg_price',
  'new_avg_price',
  'new_cust_price',
  'new_first_avg',
  'new_acq_cost',
  'uv_cost',
  'uv_value',
  'session_cost',
]);

const PERCENT_KEYS = new Set<string>([
  'cost_rate',
  'ratio',
  'progress',
  'base_second_purchase_rate',
]);

const DEFAULT_KEYS = new Set<string>([
  'roi',
  'sce_roi',
  'cpa',
  'sce_cpa',
  'cpc',
  'cpm',
  'effect_ad',
  'user_mkt',
  'kol',
  'alliance',
  'other',
  'brand_mkt',
]);

export function isSiteSensitiveMetric(key: string): boolean {
  return MONEY_KEYS.has(key) || PERCENT_KEYS.has(key) || DEFAULT_KEYS.has(key);
}

function fieldTypeFor(key: string): FieldType {
  if (MONEY_KEYS.has(key)) return 'money';
  if (PERCENT_KEYS.has(key)) return 'percent';
  return 'default';
}

export function maskSiteMetric(formatted: string, key: string, userLevel: number): string {
  if (!isSiteSensitiveMetric(key)) return formatted;
  return securityFilter(formatted, 'L2', userLevel, fieldTypeFor(key)).value ?? '锁定';
}

export function formatSiteMetric(key: string, value: number, formatter: Formatter, userLevel: number): string {
  return maskSiteMetric(formatter(value), key, userLevel);
}
